<template>
  <div class="navigation noUserSelect">
    <div class="navigation-panel" v-if="active">
      <div class="navigation-panelGroup m-noBorder">
        <div class="navigation-panelItem m-bottom20">
          <div class="navigation-panelItemIcon">
            <icon-com name="share"></icon-com>
          </div>
          <div class="navigation-panelItemText">Feeds</div>
        </div>
        <template v-for="(feedGroup, feedGroupIndex) in feeds">
          <div
            class="navigation-panelItem m-bottom5 m-clickable"
            :class="{ 'm-active' : currentFeed === feedGroupIndex }"
            @click="changeFeedTo(feedGroupIndex)"
            v-if="!Array.isArray(feed)"
            v-for="feed in feedGroup"
          >
            <div class="navigation-panelItemIcon" :style="{ 'color' : feed.color }">
              <icon-com
                :name="(feedGroup[0].public) ? 'public' : 'private'"
                size="small"
              ></icon-com>
            </div>
            <div class="navigation-panelItemText"><span v-if="!feed.plural">...</span>{{feed.plural}}</div>
            <div class="navigation-panelFeedCount">
              <icon-com
                :text="feedGroup.length - 1"
              ></icon-com>
            </div>
          </div>
        </template>

        <div class="navigation-panelItem m-top5 m-clickable" :class="{'m-highlight' : !feeds.length, 'm-disabled' : addNewFeedPage}" @click="goTo">
          <div class="navigation-panelItemIcon">
            <icon-com name="plus"></icon-com>
          </div>
          <div class="navigation-panelItemText">Add New Feed</div>
        </div>
      </div>
      <div class="navigation-panelGroup m-last">
        <div class="navigation-panelItem m-clickable" @click="logout">
          <div class="navigation-panelItemIcon">
            <icon-com name="logout"></icon-com>
          </div>
          <div class="navigation-panelItemText">Logout</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      active: true,
      addNewFeedPage: false
    }
  },
  computed: {
    feeds () {
      return this.$store.state.feeds
    },
    currentFeed () {
      return this.$store.state.currentFeed
    }
  },
  watch: {
    '$route' (to, from) {
      this.addNewFeedPage = to.path === '/addNewFeed'
    }
  },
  mounted () {
    this.addNewFeedPage = this.$router.history.current.path === '/addNewFeed'
  },
  methods: {
    goTo (link) {
      this.$http.post(
        'http://api.lootbox.se/addType',
        {
          plural: '',
          singular: '',
          dataTypes: []
        },
        {
          emulateJSON: true,
          withCredentials: true
        }
      ).then(({body}) => {
        this.$store.commit('addNewType', body)
        this.changeFeedTo(this.feeds.length - 1)
        this.$router.push('/addNewFeed')
      }, () => {
        console.log('Fail!')
      })
    },
    changeFeedTo (index) {
      this.$router.push('/')
      this.$store.commit('currentFeed', index)
    },
    logout () {
      this.$router.push('/')
      this.$http.get(
        'http://api.lootbox.se/logout',
        {
          emulateJSON: true,
          withCredentials: true
        }
      ).then(({body}) => {
        this.$store.commit('wipeUserInfo')
      }, () => {
        console.log('Fail!')
      })
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('navigation')
  width: 285px
  position: relative
  z-index: 10

  +element('nav')
    display: flex
    align-items: center
    position: relative
    height: 90px
    box-sizing: border-box
    border-bottom: 2px solid $divider

  +element('panelIcon')
    width: 30px
    height: 30px
    position: relative
    left: 30px

  +element('closePanelIcon')
    width: 30px
    height: 30px
    position: absolute
    right: 30px

  +element('panel')
    background-color: #FFF
    position: absolute
    top: 0
    left: 0px
    width: 285px
    height: 100vh
    box-sizing: border-box
    box-shadow: 0 10px 30px 0 rgba(0,0,0,.05)

  +element('panelGroup')
    padding: 30px
    border-bottom: 2px solid $divider

    +modifier('types')
      height: calc(100% - 283px)
      overflow: scroll

    +modifier('last')
      position: absolute
      bottom: 0
      background: #FFF
      width: 100%
      border-bottom: none
      box-sizing: border-box

    +modifier('noBorder')
      border: none

  +element('panelItem')
    line-height: 30px
    height: 30px
    display: flex
    cursor: default
    position: relative
    transition: .3s
    border-radius: 20px

    +modifier('bottom20')
      margin-bottom: 20px

    +modifier('bottom10')
      margin-bottom: 10px

    +modifier('bottom5')
      margin-bottom: 5px

    +modifier('top5')
      top: 5px
      margin-bottom: 5px

    +modifier('active')
      color: #3E66F6
      box-shadow: inset 0 0 0 1px rgba(0,0,0,.1), 0 2px 4px rgba(0,0,0,.05)

    +modifier('clickable')
      cursor: pointer

    +modifier('disabled')
      cursor: default
      user-select: none
      pointer-events: none
      opacity: .3


  +element('panelItemIcon')
    width: 30px
    height: 30px
    margin-right: 20px
    display: flex
    align-items: center
    justify-content: center

  +element('panelItemText')
    height: 30px
    line-height: 30px

  +element('panelFeedCount')
    height: 30px
    white-space: nowrap
    position: absolute
    right: 0px
    display: flex
    align-items: center

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue